import styled from '@emotion/styled';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box, TableContainer, Typography } from '@mui/material';

export const Container = styled(TableContainer)`
  display: flex;
  min-height: 300px;
  align-items: center;
  justify-content: center;
`;

export const ErrorOutlineIconStyled = styled(ErrorOutlineIcon)``;

export const TypographyStyled = styled(Typography)`
  padding-top: 10px;
  padding-bottom: 20px;
`;

export const TitleContainer = styled.div`
  padding-bottom: 20px;
  display: flex;
  align-items: center;
`;

export const ModalTitle = styled.span`
  margin-left: 8px;
`;

export const BoxStyled = styled(Box)`
  display: 'flex';
  justify-content: 'between';
  vertical-align: 'center';
  padding-bottom: '20px';
`;
